import { z } from 'zod';

export const wasteReasonStatSchema = z.object({
  reason: z.string(),
  count: z.number(),
  cost: z.number(),
});

export const dashboardStatsSchema = z.object({
  siteId: z.string(),
  siteName: z.string(),
  period: z.string(),
  inventory: z.object({
    totalItems: z.number(),
    lowStockItems: z.number(),
    expiringItems: z.number(),
    totalValue: z.number(),
  }),
  procurement: z.object({
    pendingPOs: z.number(),
    inTransitPOs: z.number(),
    totalPOValue: z.number(),
    pendingInvoices: z.number(),
    pendingInvoiceValue: z.number(),
  }),
  production: z.object({
    activePrepLists: z.number(),
    completedPrepLists: z.number(),
    totalPrepItems: z.number(),
    completedPrepItems: z.number(),
  }),
  waste: z.object({
    totalLogs: z.number(),
    totalCost: z.number(),
    preConsumerCost: z.number(),
    postConsumerCost: z.number(),
    topReasons: z.array(wasteReasonStatSchema),
  }),
  kpis: z.object({
    foodCostPercentage: z.number(),
    wastePercentage: z.number(),
    forecastAccuracy: z.number(),
    orderFillRate: z.number(),
    inventoryTurnover: z.number(),
  }),
  trends: z.object({
    foodCostTrend: z.array(z.number()),
    wasteTrend: z.array(z.number()),
    inventoryValueTrend: z.array(z.number()),
  }),
  generatedAt: z.string(),
});

export type DashboardStats = z.infer<typeof dashboardStatsSchema>;
export type WasteReasonStat = z.infer<typeof wasteReasonStatSchema>;

export const dashboardStatsResponseSchema = z.object({data: dashboardStatsSchema,});

export type DashboardStatsResponse = z.infer<typeof dashboardStatsResponseSchema>;

export type ReportPeriod = 'today' | 'week' | 'month' | 'quarter';

export const PERIOD_LABELS: Record<ReportPeriod, string> = {
  today: 'Today',
  week: 'This Week',
  month: 'This Month',
  quarter: 'This Quarter',
};
